import type { MissionDraft } from "@rakazo/contracts";

export type { MissionDraft } from "@rakazo/contracts";
export { MissionDraftSchema } from "@rakazo/contracts";
export function prepareMissionDraftSubmission(
  draft: MissionDraft,
  command: object,
  version: number,
  makeKey: () => string,
) {
  const fingerprint = JSON.stringify(command);
  const submission =
    draft.submission?.fingerprint === fingerprint
      ? draft.submission
      : { fingerprint, version, operationKey: makeKey() };
  return {
    draft: { ...draft, submission },
    command: { ...command, version: submission.version, operationKey: submission.operationKey },
  };
}
export function sameMissionDraft(a: MissionDraft, b: MissionDraft) {
  return (
    a.text === b.text &&
    a.target === b.target &&
    a.submission?.operationKey === b.submission?.operationKey
  );
}
